/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetInvOutReportQuery } from '../../models/get-inv-out-report-query';
import { GetInvOutReportQueryResult } from '../../models/get-inv-out-report-query-result';

export interface ApiNurseryManagerReportsGetInvOutReportPost$Plain$Params {
      body?: GetInvOutReportQuery
}

export function apiNurseryManagerReportsGetInvOutReportPost$Plain(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerReportsGetInvOutReportPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetInvOutReportQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerReportsGetInvOutReportPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetInvOutReportQueryResult>;
    })
  );
}

apiNurseryManagerReportsGetInvOutReportPost$Plain.PATH = '/api/NurseryManager/Reports/GetInvOutReport';
